export enum PoolShape {
  RECTANGULAR = "Rectangular",
  ROUND = "Round",
  KIDNEY = "Kidney",
  SQUARE = "Square",
}

export const poolShapeMap = {
  [PoolShape.RECTANGULAR]: "Rectangular",
  [PoolShape.ROUND]: "Round",
  [PoolShape.KIDNEY]: "Kidney",
  [PoolShape.SQUARE]: "Square",
};
